<template>
  <div class="list-item">
    <div class="list-tit">
      <i class="zhang-icon el-icon-document"></i>
      <span class="zhang-tit" title="回放列表">回放列表</span>
      <div class="rig-btn" @click="showListEvent">
        <template v-if="!showList">
          <i class="el-icon-plus"></i> 展开
        </template>
        <template v-else>
          <i class="el-icon-minus"></i> 收起
        </template>
      </div>
    </div>
    <ul class="list-jie" v-if="showList">
      <li v-for="replayItem in replayList" :key="replayItem.id">
        <i class="jie-icon el-icon-video-play"></i>
        <span  class="jie-tit" style="cursor: pointer" :title="replayItem.roomName">{{replayItem.roomName}}</span>
        <div class="rig-btn" v-if="showTagType == 1" @click="toLog">登录</div>
        <div class="rig-btn" v-else-if="showTagType == 3">暂未发布</div>
<!--        <div class="rig-btn" v-else-if="showTagType == 2" @click="toShow(replayItem)">观看</div>-->
        <div class="rig-btn" v-else-if="showTagType == 4" @click="toShow(replayItem)">观看</div>
      </li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: ['replayList','showTagType','isOpen','userId'],
  data () {
    return {
      showList: false
    }
  },
  mounted () {
    if(this.isOpen){
      this.showList = true
    }
  },
  methods: {
    showListEvent () {
      this.showList = !this.showList
    },
    toShow(item){
      window.open(item.publishUrl+this.userId,"_blank");
    },
    toLog(){
      this.$parent.toLog();
    },
    showTag(type){
      if(type == 0){
        this.$message({
          message: "视频转码中",
          type: 'error'
        });
      }
      if(type == 1){
        this.$message({
          message: "请登录",
          type: 'error'
        });
      }
      if(type == 2){
        this.$message({
          message: "请报名",
          type: 'error'
        });
      }if(type == 3){
        this.$message({
          message: "暂未发布",
          type: 'error'
        });
      }
      return false
    },
  }
}
</script>

<style scoped lang="less">

</style>
